import React from 'react';
import Container from "../../../shared/ui/container/Container";
import SuggestionList from "../../../features/productSearch/ui/suggestions/SuggestionList";
import SearchFilterWidget from "../../../widget/searchProducts/SearchFilterWidget";
import {ProductList} from "../../../features/productSearch";
import ProductLoadMore from "../../../features/productSearch/ui/products/ProductLoadMore";
import styled from "styled-components";
import {ToggleCartButton} from "../../../features/goods/toggle-goods-to-cart";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

const StyledWidget = styled.div`
    padding-bottom: 50px;
`
/**
 *  Составной (composed) виджет для хост-приложения в режиме Page, включающий компоненты:
 *   SuggestionList - подсказки
 *   SearchFilterWidget - фильтр
 *   ProductList - результат поиска
 *   ProductLoadMore - кнопка/механизм подгрузки дополнительных товаров
 *
 * @returns {JSX.Element} -
 */
const PageProductSearchWidget = () => {
    return (
        <Container>
            <StyledWidget onClick={(e: any) => e.stopPropagation()}
                          className={`${GLOBAL_STYLE_CONFIG.splitByPrefix('content')}`}
            >
                <SuggestionList/>
                <SearchFilterWidget/>
                <ProductList ToggleToCartButtonSlot={ToggleCartButton}/>
                <ProductLoadMore/>
            </StyledWidget>
        </Container>
    );
};

export default PageProductSearchWidget;